import React, { useContext, useEffect } from "react";
import { Store } from "../../context/Store";

import RotateIcon from "../../assets/Images/Mobile/Rotate.png";

import { Overlay } from "./LandscapeOverlayStyles";

const LandscapeOverlay: React.FC = () => {
  const { dispatch } = useContext(Store);

  useEffect(() => {
    // onComponentWillMount, We disable scroll on website
    document.body.style.overflow = "hidden";
    dispatch({
      type: "TOGGLE_PAUSE",
    });
    return () => {
      //onComponentUnmount, we reset the overflow
      document.body.style.overflow = "";

      dispatch({
        type: "TOGGLE_PAUSE",
      });
    };
  }, [dispatch]);

  return (
    <Overlay>
      <img src={RotateIcon} alt="Rotate Icon" />
      <p>Please rotate your phone to portrait mode for optimal experience</p>
    </Overlay>
  );
};

export default LandscapeOverlay;
